export const breakpoints = [0, 560, 960, 1280, 1600, 1920, 2560];

export function matchMediaQuery(minWidth : any, maxWidth ? : any) {
    if (!maxWidth) {
        return window.matchMedia(`screen and (min-width: ${minWidth}px)`).matches;
    }
    return window.matchMedia(`screen and (max-width: ${maxWidth}px) and (min-width: ${minWidth}px)`).matches;
};

export function getBreakpoint() {
  
    const matchingBps = breakpoints.filter((bp, i) => {
        if (i === breakpoints.length - 1) {
            return matchMediaQuery(bp);
        }
        if (matchMediaQuery(bp, breakpoints[i + 1])) {
            return true;
        }
        return false;
    });
    if (matchingBps.length <= 0) {
        return '0';
    }
    return String(matchingBps[0]);
};